import type { Entity } from "@bios/types";
import { Card } from "./Card.js";
import { Pill } from "./Pill.js";

interface EntityCardProps {
  entity: Entity;
  mentionCount?: number;
}

export function EntityCard({ entity, mentionCount }: EntityCardProps) {
  return (
    <Card>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
        <div>
          <div style={{ fontSize: 11, color: "var(--bios-text-muted)", textTransform: "uppercase", letterSpacing: "0.06em" }}>
            {entity.type}
          </div>
          <h4 style={{ margin: "4px 0 0", fontSize: 17, fontWeight: 600 }}>{entity.name}</h4>
        </div>
        <Pill>{entity.module}</Pill>
      </div>
      {entity.description && (
        <p style={{ fontSize: 13, color: "var(--bios-text-muted)", lineHeight: 1.5, margin: "8px 0 0" }}>
          {entity.description}
        </p>
      )}
      {typeof mentionCount === "number" && (
        <div style={{ marginTop: 12, fontSize: 12, color: "var(--bios-text-faint)" }}>
          {mentionCount} mentions
        </div>
      )}
    </Card>
  );
}
